import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { LandingV4Testimonial } from '~/landingV4/types/testimonial.types'

interface Props {
  testimonial: LandingV4Testimonial
}

export default function TestimonialCard({ testimonial }: Props): React.ReactElement {
  const { t } = useTranslation('abTestLanding')
  const { avatarSrc, highlighted, id, initial, name } = testimonial

  return (
    <figure
      className={`flex w-80 shrink-0 flex-col gap-4 rounded-4 border border-black/10 p-6 shadow-sm md:w-96 ${
        highlighted ? 'bg-lime-200' : 'bg-white'
      }`}
    >
      {avatarSrc ? (
        <ResponsiveImage
          alt={name}
          className="h-40 w-40 shrink-0 overflow-hidden rounded-large"
          fit="cover"
          height={160}
          imageClassName="h-40 w-40 object-cover"
          srcKey={avatarSrc}
          width={160}
        />
      ) : (
        <span className="flex h-40 w-40 shrink-0 items-center justify-center rounded-large bg-blue-iris text-2xl font-semibold text-white">
          {initial}
        </span>
      )}
      <div className="flex items-start justify-between gap-2">
        <figcaption className="min-w-0">
          <p className="text-xs font-bold text-black-ink">{name}</p>
          <p className="whitespace-nowrap text-sm font-medium text-gray-900">{t(`v4.hero.testimonials.${id}.role`)}</p>
        </figcaption>
        <p aria-hidden className="shrink-0 text-sm leading-none text-orange md:text-lg">
          ★★★★★
        </p>
      </div>
      <blockquote className="text-xs font-bold leading-relaxed text-black-ink">
        {t(`v4.hero.testimonials.${id}.body`)}
      </blockquote>
    </figure>
  )
}
